import {Component, Inject, Input, LOCALE_ID, OnChanges} from '@angular/core';

@Component({
  selector: 'app-credit-usage',
  templateUrl: './credit-usage.component.html',
  styleUrls: ['./credit-usage.component.scss'],
  standalone: false,
})
export class CreditUsageComponent implements OnChanges {
  @Input() images = 0;
  @Input() gifs = 0;
  @Input() videos = 0;
  @Input() total = 0;
  @Input() totalUsed = 0;
  @Input() title = '';

  public formattedTotal = '';
  public formattedTotalUsed = '';
  public formattedPercentageUsed = '';
  public progressBarProcentage = '';
  public chartValue = 0;
  public open = false;

  constructor(@Inject(LOCALE_ID) public locale: string) {}

  ngOnChanges(): void {
    this.formattedTotalUsed = this.totalUsed.toLocaleString('nl-NL', {
      maximumFractionDigits: 0,
    });

    this.chartValue = this.total > 0 ? (this.totalUsed / this.total) * 100 : 100;

    this.formattedPercentageUsed =
      this.total > 0
        ? ((this.totalUsed / this.total) * 100).toLocaleString('nl-NL', {
            maximumFractionDigits: 1,
          }) + '%'
        : '100%';

    this.progressBarProcentage =
      this.total > 0
        ? Math.round((this.totalUsed / this.total) * 100).toLocaleString('nl-NL', {
            maximumFractionDigits: 0,
          }) + '%'
        : '100%';

    this.formattedTotal = this.total.toLocaleString('nl-NL', {
      maximumFractionDigits: 0,
    });
  }

  public toggleOpen() {
    this.open = !this.open;
  }
}
